export function toLocalLocale(locale: string) {
  return locale === 'fr-ch' ? 'fr' : locale;
}
